import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-18 11:28:39
 * @LastEditTime: 2021-05-25 19:17:25
 * @LastEditors: wangshengqiang
 * @Description: 日期选择空间
 */
import React from 'react';
import { DateSelect } from 'zarm';
import moment from 'moment';
export default (props => {
  return /*#__PURE__*/React.createElement(DateSelect, _extends({
    title: "\u9009\u62E9\u65E5\u671F"
  }, props, {
    onOk: value => {
      const dateString = moment(value).format('YYYY-MM-DD');
      props.onChange && props.onChange(dateString);
    }
  }));
});